import { PageStatus } from '@tinct/core-api-models';

export const PAGE_STATUS_CONFIG: Record<
  PageStatus,
  { label: string; dotColor: string; hideDot?: boolean }
> = {
  draft: { label: 'Draft', dotColor: 'bg-ring' },
  published: { label: 'Published', dotColor: 'bg-teal-500' },
  unpublished: { label: 'Unpublished', dotColor: 'bg-ring' },
  waiting: { label: 'Waiting', dotColor: 'bg-background border border-ring' },
  queued: { label: 'Queued', dotColor: 'bg-background border border-ring' },
  generating: { label: 'Generating...', dotColor: '', hideDot: true },
  ready: { label: 'Ready', dotColor: 'bg-primary' },
  error: { label: 'Error', dotColor: 'bg-rose-500' },
  excluded: { label: 'Excluded', dotColor: 'bg-ring' },
  excluded_conflict: { label: 'Excluded conflict', dotColor: 'bg-rose-500' },
};
